import React from "react";
import { services } from "../../utility/Navigation";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div style={{ backgroundColor: "#0a1530" }}>
      <section className="service-area mt-lg-4 mb-10">
        <div className=" mt-5 text-center">
          <h1
            className="display-5 fw-bold mb-4 animate__animated animate__fadeInDown"
            style={{
              fontFamily: "'Goldman', sans-serif",
              // color: "#002147",
              color: "#fff",
              animationDelay: "0.1s",
            }}
          >
            Our Solutions
          </h1>
        </div>

        {/* background shape */}
        <div className="service__shape wow slideInRight">
          <img
            className="sway_Y__animation"
            src="/assets/images/shape/service-bg-shape.png"
            alt="shape"
          />
        </div>

        <div className="container">
          <div className="d-flex flex-wrap gap-4 align-items-center justify-content-between">
            <div className="section-header">
              <h5
                className="wow fadeInLeft"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <img
                  className="me-1"
                  src="/assets/images/icon/section-title.png"
                  alt="icon"
                />
                What We OFFER
              </h5>
              <h2
                className="wow fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ color: "#fff" }}
              >
                Examination & Learning Solutions
              </h2>
            </div>
            <Link
              to="/oursolutions"
              className="btn-one wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              View All Solutions{" "}
              <i className="fa-regular fa-arrow-right-long" />
            </Link>
          </div>

          {/* dynamic services list */}
          <div className="row g-4">
            {services.map((service) => (
              <div
                key={service.id}
                className="col-lg-4 col-md-6 g-4  wow bounceInUp card-hover"
                data-wow-delay={`${service.delay}s`}
                data-wow-duration="1000ms"
              >
                <div className={`service__item`}>
                  <div className="service__icon">
                    <img
                      src={service.icon}
                      alt={service.title}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                      className="img-hover"
                    />
                  </div>
                  <h4 className="fs-4 fw-bold fs-5 service__item_hover">
                    <a href={service.link}>{service.title}</a>
                  </h4>
                  <p style={{fontSize:'17px'}} >{service.description}</p>
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <Link
                      to="/oursolutions"
                      className="btn-one1 wow fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      View More {"\u00a0"}
                      {"\u00a0"}
                      <i className="fa-regular fa-arrow-right-long" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
